import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useDisableSplitTest = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (payload: { id: string }) => {
      dispatch({
        type: 'DISABLE_SPLIT_TEST',
        payload,
      });
    },
    [dispatch],
  );
};
